import {
  appQueryClient,
  type NewApiErrorResponse,
  type UseAppMutationOptions
} from '@libs/data-access/queries'
import { useMutation } from '@tanstack/react-query'

import { membershipContractCacheKeys } from '../../../User/Membership/Contract/membership.contract.cacheKeys'
import {
  postBulkDpaeForContracts,
  type PostBulkDpaeForContractsOptions
} from '../contract.dpae.api'
import { contractDpaeQueryKeys } from '../contract.dpae.cacheKeys'

export const useBulkPostForContracts = (
  mutationOptions?: UseAppMutationOptions<
    {},
    NewApiErrorResponse,
    PostBulkDpaeForContractsOptions
  >
) =>
  useMutation({
    ...mutationOptions,
    mutationKey: contractDpaeQueryKeys.post_dpae_contracts_bulk(),
    mutationFn: opts => postBulkDpaeForContracts(opts),
    onSuccess: (...args) => {
      mutationOptions?.onSuccess?.(...args)
      appQueryClient.invalidateQueries({
        queryKey: membershipContractCacheKeys.fetch_contracts_eligible_for_dpae(
          {}
        )
      })
    }
  })
